import React, { useState } from 'react'
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react'
import Typography from '../atoms/Typography'

interface ExpandableListItem {
  id: string
  title: string
  subtitle?: string
}

interface ExpandableListProps {
  /** Undefined or empty renders a loading row — callers show the list only once they know it has items. */
  items: ExpandableListItem[] | undefined
}

const ExpandableList: React.FC<ExpandableListProps> = ({ items }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex items-center gap-1 self-center text-sm text-light-green-500 underline-offset-2 hover:underline"
      >
        {expanded ? (
          <>
            Hide list <IconChevronUp size={14} />
          </>
        ) : (
          <>
            Show list <IconChevronDown size={14} />
          </>
        )}
      </button>

      {expanded && (
        <div className="max-h-48 w-full overflow-y-auto rounded-lg border border-gray-700 bg-gray-900 p-2">
          {items && items.length > 0 ? (
            items.map((item) => (
              <div key={item.id} className="flex flex-col truncate border-b border-gray-700 px-3 py-2 last:border-b-0">
                <Typography variant="sm-medium" className="truncate text-gray-50">
                  {item.title}
                </Typography>
                {item.subtitle && (
                  <Typography variant="xs" className="truncate text-gray-400">
                    {item.subtitle}
                  </Typography>
                )}
              </div>
            ))
          ) : (
            <div className="py-2 text-center text-sm text-gray-400">Loading…</div>
          )}
        </div>
      )}
    </>
  )
}

export default ExpandableList
